import { EntityTypes, IGroupSpace, IGroupSpaceResource, IUserResource } from "@sol/sdk";
import { IApiMutationFunction, createApiMutationHook } from "@sol/sdk/utils/api";
import {
    RelationalFilter,
    RelationalValue,
    mapRelationalFilterToIRI,
    mapRelationalValue,
} from "@sol/sdk/utils/filters";

export type IGroupSpaceUpdateMutationParameters = {
    groupSpace?: RelationalValue<IGroupSpaceResource>;
    learners?: RelationalFilter<IUserResource>;
    title?: string;
};

export type IGroupSpaceUpdateMutationResult = IGroupSpace;

export const groupSpaceUpdateMutation: IApiMutationFunction<IGroupSpaceUpdateMutationParameters> = ({
    groupSpace,
    learners,
    title,
}) => {
    return {
        method: "PUT",
        url: `/group_spaces/${mapRelationalValue(groupSpace)}`,
        data: {
            learners: mapRelationalFilterToIRI(EntityTypes.USER, learners),
            title,
        },
    };
};

export const useGroupSpaceUpdateMutation = createApiMutationHook<
    IGroupSpaceUpdateMutationParameters,
    IGroupSpaceUpdateMutationResult
>(groupSpaceUpdateMutation);
